export default [
    {
        /** 退出系统 */
        name: 'queryUserLists',
        url: '/lists'
    },
    {
        name: 'addUser',
        url: '/add'
    },
    {
        name: 'updateUser',
        url: '/update'
    },
    {
        name: 'login',
        url: '/login'
    }
];
